import api from "@/api/api-config";

export async function getMonthlyReport(userId) {
  return await api.get(`driver/report/${userId}`);
}
